module.exports = __webpack_public_path__ + "static/img/product3s-5.f51b45f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3s-5.jpg
// module id = QzI8
// module chunks = 0